import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-378cd13d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "tw-flex 2xl:tw-w-1/2 xl:tw-mb-[0px] tw-mb-[10px] tw-h-[70px] tw-w-[70px] bg-skeleton"
}

import { getProfileImage } from "@/services/org";
import { computed, onMounted, Ref, ref, watch } from "vue";
import { getImageData } from "@/utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'orgAvatar',
  props: {
    srcImg: {},
    imgId: {},
    name: {},
    className: {},
    imgClassName: {}
  },
  setup(__props: any) {

const props = __props;


const img = ref<string | null>(null);
const loadingAvatar: Ref<boolean> = ref(false);

onMounted(async () => {
  if (props.imgId) {
    getAvatarImg(props.imgId);
  }
});

watch(
  () => props.imgId,
  async (value) => {
    if (value) {
      getAvatarImg(value);
    }
  },
);

const getAvatarImg = async (imgId) => {
  try {
    loadingAvatar.value = true;
    const res = await getProfileImage(imgId);
    const imageDetails = res.data.data;
    const file = await getImageData(imageDetails);
    img.value = URL.createObjectURL(file);
  } catch (error) {
    console.error("Error in fetching image", error);
  } finally {
    loadingAvatar.value = false;
  }
};

const letterName = computed(() => {
  const words = props.name?.split(" ");
  if (words?.length && words.length > 1) {
    return `${words[0].charAt(0)}${words[1].charAt(0)}`.toUpperCase();
  }
  return props.name?.charAt(0).toUpperCase() || "";
});

return (_ctx: any,_cache: any) => {
  return (_ctx.imgId || _ctx.srcImg)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["avatar-wrapper", `tw-bg-[transparent] global-avatar tw-justify-start ${
      _ctx.className || ''
    }`])
      }, [
        (!loadingAvatar.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              alt: "avatar",
              src: img.value || _ctx.srcImg,
              class: _normalizeClass(_ctx.imgClassName)
            }, null, 10, _hoisted_1))
          : (_openBlock(), _createElementBlock("div", _hoisted_2))
      ], 2))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(`tw-bg-[#211F58] global-avatar tw-justify-center tw-min-w-[70px] tw-w-[70px] tw-rounded-[5.38px] ${
      _ctx.className || ''
    }`)
      }, [
        _createElementVNode("p", null, _toDisplayString(letterName.value), 1)
      ], 2))
}
}

})